import { createSelector } from "reselect";

import { FilterContent, GetIncorrectContentModules } from "./types";

export type WrongModuleModeNotAvailableDueToDevice = (state: any) => boolean;

export default function makeWrongModuleModeNotAvailableDueToDevice(
  getIncorrectContentModules: GetIncorrectContentModules,
  filterContentModuleForDevice: FilterContent
): WrongModuleModeNotAvailableDueToDevice {
  return createSelector(getIncorrectContentModules, incorrectContentModules => {
    const incorrectContentModulesThatAreSupportedByDevice =
      incorrectContentModules.filter(filterContentModuleForDevice);

    return (
      incorrectContentModulesThatAreSupportedByDevice.size === 0 &&
      incorrectContentModules.size > 0
    );
  });
}
